export default __webpack_public_path__ + "static/media/image-form.7bd1f96b.jpg";